module.exports = __webpack_public_path__ + "img/modulo_07.ae58c4b.svg";